"use client";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG.client";
import styles from "./BookingBar.module.scss";
import { useAppContext } from "@/context/AppContext";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

export const BookingBar = () => {
  const { setBookingModal } = useAppContext();
  const { getLabel } = useGlobalContext();
  return (
    <button
      className={`button-reset ${styles["booking-bar"]}`}
      onClick={() => {
        setBookingModal({ open: true });
      }}
    >
      <span className={styles["label"]}>
        {getLabel("booking_bar_label", "jetzt reservieren")}
      </span>
      <CustomSVG
        iconKey="booking-circle"
        className={styles["arrow"]}
        wrapper="span"
        width={32}
        height={32}
        aria-hidden={true}
      />
    </button>
  );
};
